import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index4',
    component: () => import(/* webpackChunkName: "tikmobileD" */ '@/views/homeD.vue')
  },
  {
    path: '/catalog',
    name: 'productListD',
    component: () => import(/* webpackChunkName: "productListD" */ '@/views/productListD.vue')
  },
  {
    path: '/topup/:id',
    name: 'payCheckoutD',
    component: () => import(/* webpackChunkName: "payCheckoutD" */ '@/views/payCheckoutD.vue')
  },
  {
    path: '/mobile',
    name: 'mobileTopupD',
    component: () => import(/* webpackChunkName: "mobileTopupD" */ '@/views/mobileTopupD.vue')
  },
  {
    path: '/checkout/:gameId/:orderNo',
    name: 'payConfirmD',
    component: () => import(/* webpackChunkName: "payConfirmD" */ '@/views/payConfirmD.vue')
  },
  {
    path: '/payResult',
    name: 'payResultD',
    component: () => import(/* webpackChunkName: "payResultD" */ '@/views/payResultD.vue')
  },
  // 法务三页正文复用 A/B/C 共用组件，legalD 只负责 D 的排版与右轨目录
  {
    path: '/privacy',
    name: 'rprivacyD',
    meta: { doc: 'privacy' },
    component: () => import(/* webpackChunkName: "legalD" */ '@/views/legalD.vue')
  },
  {
    path: '/tos',
    name: 'reulaD',
    meta: { doc: 'tos' },
    component: () => import(/* webpackChunkName: "legalD" */ '@/views/legalD.vue')
  },
  {
    path: '/conduct',
    name: 'ractionD',
    meta: { doc: 'conduct' },
    component: () => import(/* webpackChunkName: "legalD" */ '@/views/legalD.vue')
  }
]

const routerD = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default routerD
